var _path, _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#8F95B2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66537 8.06874L11.6666 10.0775C11.869 10.2799 11.9964 10.5647 11.9964 10.872C11.9964 11.4941 11.4942 11.9963 10.8721 11.9963C10.5648 11.9963 10.28 11.8689 10.0776 11.6665L8.06886 9.66525C7.25937 10.1824 6.29248 10.4972 5.25063 10.4972C2.34994 10.4972 0.00390625 8.15119 0.00390625 5.2505C0.00390625 2.34982 2.34994 0.00378418 5.25063 0.00378418C8.15131 0.00378418 10.4973 2.34982 10.4973 5.2505C10.4973 6.28486 10.19 7.25175 9.66537 8.06874ZM1.50297 5.2505C1.50297 7.31921 3.18192 8.99816 5.25063 8.99816C7.31933 8.99816 8.99829 7.31921 8.99829 5.2505C8.99829 3.1818 7.31933 1.50285 5.25063 1.50285C3.18192 1.50285 1.50297 3.1818 1.50297 5.2505Z",
    fill: "currentColor"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Search")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSearch);
export default __webpack_public_path__ + "static/media/table-search.aad1a53a.svg";
export { ForwardRef as ReactComponent };